import { Component, h, Prop, State, Event, EventEmitter, Host, Listen } from '@stencil/core';

@Component({
  tag: 'anchor-card',
  styleUrl: 'card.scss',
  shadow: true,
})
export class Card {
  /**
   * Where should the user go, when clicking on the card.
   */
  @Prop() url = undefined;

  /**
   * Text alignment of the card. Can be either 'center' or 'left'.
   */
  @Prop({ reflect: true }) align: 'center' | 'left' = 'center';

  /**
   * Content alignment of the card. Can be either 'top', 'center' or 'bottom'.
   */
  @Prop({ reflect: true }) verticalAlign: 'top' | 'center' | 'bottom' = 'top';

  /**
   * Whether to show a border around the card.
   */
  @Prop({ reflect: true }) showBorder: boolean = true;

  /**
   * Whether to show an icon in the card.
   */
  @Prop({ reflect: true }) showIcon: boolean = false;

  /**
   * The current state of the card.
   */
  @State() state: 'default' | 'hover' | 'pressed' | 'focus' = 'default';

  /**
   * Event emitted when the card is clicked.
   */
  @Event() clickEvent: EventEmitter;

  /**
   * Handles the click event of the card.
   */
  @Listen('click')
  handleClick(_e: PointerEvent) {
    this.clickEvent.emit(true);
  }

  render() {
    return (
      <Host>
        <a
          href={this.url}
          class={`
            anchor-c-card 
            ${this.align} 
            ${this.state} 
            ${this.showBorder ? 'border' : ''}
            ${this.showIcon ? 'icon' : ''}
            anchor-c-card__vertical-${this.verticalAlign}
          `}
          tabindex="0"
        >
          <slot name="illustration" />
          <slot name="image" />
          <slot name="header" />
          {this.showIcon ? <anchor-icon part="icon" class="anchor-c-card__icon" name="chevron-right" /> : null}
          <slot name="text" />
        </a>
      </Host>
    );
  }
}
